<footer class="admin-footer d-flex flex-column flex-md-row align-items-center justify-content-end">
  <p class="">Copyright © {{CurrentYear}} <span>Teksun Inc.</span> All Rights Reserved.</p>
</footer>
